export default "__VITE_ASSET__a2892dac__"